import { render } from "./DateSwitch.vue?vue&type=template&id=3f03cc00"
import script from "./DateSwitch.vue?vue&type=script&lang=js"
export * from "./DateSwitch.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__